const baseUrl = "https://strapi-ab9t.onrender.com";

export default baseUrl;
